// Generated by scripts/update-french-subdivisions.py; do not edit individual entries.
// Source: https://geo.api.gouv.fr/departements and /regions; Licence Ouverte 2.0.
export const FRENCH_SUBDIVISIONS_RETRIEVED_AT = '2026-09-28';
export const FRENCH_SUBDIVISIONS = [
    {
        countryCode: 'FR',
        code: '01',
        name: 'Ain',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '02',
        name: 'Aisne',
        regionCode: '32',
        region: 'Hauts-de-France',
    },
    {
        countryCode: 'FR',
        code: '03',
        name: 'Allier',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '04',
        name: 'Alpes-de-Haute-Provence',
        regionCode: '93',
        region: "Provence-Alpes-Côte d'Azur",
    },
    {
        countryCode: 'FR',
        code: '05',
        name: 'Hautes-Alpes',
        regionCode: '93',
        region: "Provence-Alpes-Côte d'Azur",
    },
    {
        countryCode: 'FR',
        code: '06',
        name: 'Alpes-Maritimes',
        regionCode: '93',
        region: "Provence-Alpes-Côte d'Azur",
    },
    {
        countryCode: 'FR',
        code: '07',
        name: 'Ardèche',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '08',
        name: 'Ardennes',
        regionCode: '44',
        region: 'Grand Est',
    },
    {
        countryCode: 'FR',
        code: '09',
        name: 'Ariège',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '10',
        name: 'Aube',
        regionCode: '44',
        region: 'Grand Est',
    },
    {
        countryCode: 'FR',
        code: '11',
        name: 'Aude',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '12',
        name: 'Aveyron',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '13',
        name: 'Bouches-du-Rhône',
        regionCode: '93',
        region: "Provence-Alpes-Côte d'Azur",
    },
    {
        countryCode: 'FR',
        code: '14',
        name: 'Calvados',
        regionCode: '28',
        region: 'Normandie',
    },
    {
        countryCode: 'FR',
        code: '15',
        name: 'Cantal',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '16',
        name: 'Charente',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '17',
        name: 'Charente-Maritime',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '18',
        name: 'Cher',
        regionCode: '24',
        region: 'Centre-Val de Loire',
    },
    {
        countryCode: 'FR',
        code: '19',
        name: 'Corrèze',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '21',
        name: "Côte-d'Or",
        regionCode: '27',
        region: 'Bourgogne-Franche-Comté',
    },
    {
        countryCode: 'FR',
        code: '22',
        name: "Côtes-d'Armor",
        regionCode: '53',
        region: 'Bretagne',
    },
    {
        countryCode: 'FR',
        code: '23',
        name: 'Creuse',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '24',
        name: 'Dordogne',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '25',
        name: 'Doubs',
        regionCode: '27',
        region: 'Bourgogne-Franche-Comté',
    },
    {
        countryCode: 'FR',
        code: '26',
        name: 'Drôme',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '27',
        name: 'Eure',
        regionCode: '28',
        region: 'Normandie',
    },
    {
        countryCode: 'FR',
        code: '28',
        name: 'Eure-et-Loir',
        regionCode: '24',
        region: 'Centre-Val de Loire',
    },
    {
        countryCode: 'FR',
        code: '29',
        name: 'Finistère',
        regionCode: '53',
        region: 'Bretagne',
    },
    {
        countryCode: 'FR',
        code: '2A',
        name: 'Corse-du-Sud',
        regionCode: '94',
        region: 'Corse',
    },
    {
        countryCode: 'FR',
        code: '2B',
        name: 'Haute-Corse',
        regionCode: '94',
        region: 'Corse',
    },
    {
        countryCode: 'FR',
        code: '30',
        name: 'Gard',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '31',
        name: 'Haute-Garonne',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '32',
        name: 'Gers',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '33',
        name: 'Gironde',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '34',
        name: 'Hérault',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '35',
        name: 'Ille-et-Vilaine',
        regionCode: '53',
        region: 'Bretagne',
    },
    {
        countryCode: 'FR',
        code: '36',
        name: 'Indre',
        regionCode: '24',
        region: 'Centre-Val de Loire',
    },
    {
        countryCode: 'FR',
        code: '37',
        name: 'Indre-et-Loire',
        regionCode: '24',
        region: 'Centre-Val de Loire',
    },
    {
        countryCode: 'FR',
        code: '38',
        name: 'Isère',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '39',
        name: 'Jura',
        regionCode: '27',
        region: 'Bourgogne-Franche-Comté',
    },
    {
        countryCode: 'FR',
        code: '40',
        name: 'Landes',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '41',
        name: 'Loir-et-Cher',
        regionCode: '24',
        region: 'Centre-Val de Loire',
    },
    {
        countryCode: 'FR',
        code: '42',
        name: 'Loire',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '43',
        name: 'Haute-Loire',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '44',
        name: 'Loire-Atlantique',
        regionCode: '52',
        region: 'Pays de la Loire',
    },
    {
        countryCode: 'FR',
        code: '45',
        name: 'Loiret',
        regionCode: '24',
        region: 'Centre-Val de Loire',
    },
    {
        countryCode: 'FR',
        code: '46',
        name: 'Lot',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '47',
        name: 'Lot-et-Garonne',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '48',
        name: 'Lozère',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '49',
        name: 'Maine-et-Loire',
        regionCode: '52',
        region: 'Pays de la Loire',
    },
    {
        countryCode: 'FR',
        code: '50',
        name: 'Manche',
        regionCode: '28',
        region: 'Normandie',
    },
    {
        countryCode: 'FR',
        code: '51',
        name: 'Marne',
        regionCode: '44',
        region: 'Grand Est',
    },
    {
        countryCode: 'FR',
        code: '52',
        name: 'Haute-Marne',
        regionCode: '44',
        region: 'Grand Est',
    },
    {
        countryCode: 'FR',
        code: '53',
        name: 'Mayenne',
        regionCode: '52',
        region: 'Pays de la Loire',
    },
    {
        countryCode: 'FR',
        code: '54',
        name: 'Meurthe-et-Moselle',
        regionCode: '44',
        region: 'Grand Est',
    },
    {
        countryCode: 'FR',
        code: '55',
        name: 'Meuse',
        regionCode: '44',
        region: 'Grand Est',
    },
    {
        countryCode: 'FR',
        code: '56',
        name: 'Morbihan',
        regionCode: '53',
        region: 'Bretagne',
    },
    {
        countryCode: 'FR',
        code: '57',
        name: 'Moselle',
        regionCode: '44',
        region: 'Grand Est',
    },
    {
        countryCode: 'FR',
        code: '58',
        name: 'Nièvre',
        regionCode: '27',
        region: 'Bourgogne-Franche-Comté',
    },
    {
        countryCode: 'FR',
        code: '59',
        name: 'Nord',
        regionCode: '32',
        region: 'Hauts-de-France',
    },
    {
        countryCode: 'FR',
        code: '60',
        name: 'Oise',
        regionCode: '32',
        region: 'Hauts-de-France',
    },
    {
        countryCode: 'FR',
        code: '61',
        name: 'Orne',
        regionCode: '28',
        region: 'Normandie',
    },
    {
        countryCode: 'FR',
        code: '62',
        name: 'Pas-de-Calais',
        regionCode: '32',
        region: 'Hauts-de-France',
    },
    {
        countryCode: 'FR',
        code: '63',
        name: 'Puy-de-Dôme',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '64',
        name: 'Pyrénées-Atlantiques',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '65',
        name: 'Hautes-Pyrénées',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '66',
        name: 'Pyrénées-Orientales',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '67',
        name: 'Bas-Rhin',
        regionCode: '44',
        region: 'Grand Est',
    },
    {
        countryCode: 'FR',
        code: '68',
        name: 'Haut-Rhin',
        regionCode: '44',
        region: 'Grand Est',
    },
    {
        countryCode: 'FR',
        code: '69',
        name: 'Rhône',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '70',
        name: 'Haute-Saône',
        regionCode: '27',
        region: 'Bourgogne-Franche-Comté',
    },
    {
        countryCode: 'FR',
        code: '71',
        name: 'Saône-et-Loire',
        regionCode: '27',
        region: 'Bourgogne-Franche-Comté',
    },
    {
        countryCode: 'FR',
        code: '72',
        name: 'Sarthe',
        regionCode: '52',
        region: 'Pays de la Loire',
    },
    {
        countryCode: 'FR',
        code: '73',
        name: 'Savoie',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '74',
        name: 'Haute-Savoie',
        regionCode: '84',
        region: 'Auvergne-Rhône-Alpes',
    },
    {
        countryCode: 'FR',
        code: '75',
        name: 'Paris',
        regionCode: '11',
        region: 'Île-de-France',
    },
    {
        countryCode: 'FR',
        code: '76',
        name: 'Seine-Maritime',
        regionCode: '28',
        region: 'Normandie',
    },
    {
        countryCode: 'FR',
        code: '77',
        name: 'Seine-et-Marne',
        regionCode: '11',
        region: 'Île-de-France',
    },
    {
        countryCode: 'FR',
        code: '78',
        name: 'Yvelines',
        regionCode: '11',
        region: 'Île-de-France',
    },
    {
        countryCode: 'FR',
        code: '79',
        name: 'Deux-Sèvres',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '80',
        name: 'Somme',
        regionCode: '32',
        region: 'Hauts-de-France',
    },
    {
        countryCode: 'FR',
        code: '81',
        name: 'Tarn',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '82',
        name: 'Tarn-et-Garonne',
        regionCode: '76',
        region: 'Occitanie',
    },
    {
        countryCode: 'FR',
        code: '83',
        name: 'Var',
        regionCode: '93',
        region: "Provence-Alpes-Côte d'Azur",
    },
    {
        countryCode: 'FR',
        code: '84',
        name: 'Vaucluse',
        regionCode: '93',
        region: "Provence-Alpes-Côte d'Azur",
    },
    {
        countryCode: 'FR',
        code: '85',
        name: 'Vendée',
        regionCode: '52',
        region: 'Pays de la Loire',
    },
    {
        countryCode: 'FR',
        code: '86',
        name: 'Vienne',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '87',
        name: 'Haute-Vienne',
        regionCode: '75',
        region: 'Nouvelle-Aquitaine',
    },
    {
        countryCode: 'FR',
        code: '88',
        name: 'Vosges',
        regionCode: '44',
        region: 'Grand Est',
    },
    {
        countryCode: 'FR',
        code: '89',
        name: 'Yonne',
        regionCode: '27',
        region: 'Bourgogne-Franche-Comté',
    },
    {
        countryCode: 'FR',
        code: '90',
        name: 'Territoire de Belfort',
        regionCode: '27',
        region: 'Bourgogne-Franche-Comté',
    },
    {
        countryCode: 'FR',
        code: '91',
        name: 'Essonne',
        regionCode: '11',
        region: 'Île-de-France',
    },
    {
        countryCode: 'FR',
        code: '92',
        name: 'Hauts-de-Seine',
        regionCode: '11',
        region: 'Île-de-France',
    },
    {
        countryCode: 'FR',
        code: '93',
        name: 'Seine-Saint-Denis',
        regionCode: '11',
        region: 'Île-de-France',
    },
    {
        countryCode: 'FR',
        code: '94',
        name: 'Val-de-Marne',
        regionCode: '11',
        region: 'Île-de-France',
    },
    {
        countryCode: 'FR',
        code: '95',
        name: "Val-d'Oise",
        regionCode: '11',
        region: 'Île-de-France',
    },
    {
        countryCode: 'FR',
        code: '971',
        name: 'Guadeloupe',
        regionCode: '01',
        region: 'Guadeloupe',
    },
    {
        countryCode: 'FR',
        code: '972',
        name: 'Martinique',
        regionCode: '02',
        region: 'Martinique',
    },
    {
        countryCode: 'FR',
        code: '973',
        name: 'Guyane',
        regionCode: '03',
        region: 'Guyane',
    },
    {
        countryCode: 'FR',
        code: '974',
        name: 'La Réunion',
        regionCode: '04',
        region: 'La Réunion',
    },
    {
        countryCode: 'FR',
        code: '976',
        name: 'Mayotte',
        regionCode: '06',
        region: 'Mayotte',
    },
];
//# sourceMappingURL=french-subdivisions.js.map